export default __webpack_public_path__ + "vision-examples-basic-ar-navigation-thumbnail-960-97cb83a556cbbece5de0dec295aa117c.png";